import React, { Fragment, useState, useContext } from "react";
import clsx from "clsx";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  Button,
  ButtonGroup,
  Popover,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import { IoMdCloudDownload } from "react-icons/io";
import { useLocation } from "react-router-dom";
import { DesignContext } from "../../context/design";
import { exportProject } from "../../apis/project";
import { uploadFile } from "../../apis/other";
import { makeBlobFromBase64 } from "../../constant/convert-image";

const useStyles = makeStyles((theme: Theme) => ({
  default: { color: theme.palette.secondary.main },
  active: { color: `${theme.palette.primary.main} !important` },
  spaceInGroup: {
    marginLeft: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
  },
  flexMiddle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  select: { height: theme.spacing(4) },
  btnSelect: {
    boxShadow: "unset",
    padding: theme.spacing(0.3),
    width: theme.spacing(4),
    height: theme.spacing(4),
    fontFamily: ["Montserrat-Bold", "Kanit-Bold"].join(","),
    minWidth: "unset",
  },
}));

const formatList = [
  {
    name: "Shapefile",
    value: "shp",
  },
  { name: "KML/KMZ", value: "kml and kmz" },
  { name: "AutoCAD (.dxf)", value: "dxf" },
  { name: "GeoTiff", value: "geotiff" },
];

const ExportData = () => {
  const classes = useStyles();
  const { state } = useLocation();
  const { map } = useContext(DesignContext);

  const [
    formatSelectEl,
    setformatSelectEl,
  ] = useState<HTMLButtonElement | null>(null);

  const _exportProject = async (event: any) => {
    const jsonState = JSON.parse(String(state));
    const bboxArray: any = map?.getBounds().toArray();
    let input: any = {
      format_export: event,
      bbox: [
        bboxArray[0][0],
        bboxArray[1][1], //bboxArray[0][1],
        bboxArray[1][0],
        bboxArray[0][1], //bboxArray[1][1],
      ],
    };

    setformatSelectEl(null);
    if (event === "geotiff") {
      let img = map?.getCanvas().toDataURL();
      const imgBlob = makeBlobFromBase64(img);
      let fd = new FormData();
      fd.append("file", imgBlob, `${jsonState._id}.png`);
      const rsUploadFile = await uploadFile(fd);
      if (rsUploadFile.data.data[0].file) {
        input.url = String(
          process.env.NODE_ENV === "production"
            ? `${process.env.REACT_APP_REANDER_UPLOAD_FILE}${rsUploadFile.data.data[0].file}`
            : rsUploadFile.data.data[0].file
        );
      }
    }

    const exportfile = await exportProject(jsonState._id, input);
    if (exportfile.status.code === 200) {
      process.env.NODE_ENV === "production"
        ? window.open(
            `${process.env.REACT_APP_REANDER_UPLOAD_FILE}${exportfile.data[0].url}`
          )
        : window.open(exportfile.data[0].url, "_blank");
    }
  };

  return (
    <Fragment>
      <Popover
        open={Boolean(formatSelectEl)}
        anchorEl={formatSelectEl}
        onClose={() => {
          setformatSelectEl(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <List component="nav" aria-label="main mailbox folders">
          {formatList.map((format) => (
            <ListItem
              key={format.value}
              button
              onClick={() => {
                _exportProject(format.value);
              }}
            >
              <ListItemText primary={format.name} />
            </ListItem>
          ))}
        </List>
      </Popover>
      <Typography variant="subtitle2" className={clsx(classes.flexMiddle)}>
        Export:
      </Typography>
      <ButtonGroup className={classes.spaceInGroup}>
        <Button
          variant="outlined"
          size="small"
          className={clsx(classes.btnSelect)}
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
            setformatSelectEl(event.currentTarget);
          }}
        >
          <IoMdCloudDownload size={24} color="#595a5a" />
        </Button>
      </ButtonGroup>
    </Fragment>
  );
};

export default ExportData;
